import React, { useState } from "react";
import styled from "styled-components";
import { TfiCrown, TfiEye } from "react-icons/tfi";
import { useMatchContext } from "../context/match_context";

const MatchDetailSpectator = () => {
  const [showSpoiler, setShowSpoiler] = useState(false);
  const { loading, error, match, gameIds } = useMatchContext();

  const switchSpoiler = (state) => {
    setShowSpoiler(!state);
  };

  if (loading) {
    return (
      <Wrapper>
        <div className="loading">
          <div className="lds-dual-ring"></div>
        </div>
      </Wrapper>
    );
  }

  if (error) {
    return (
      <Wrapper>
        <div>Ha ocurrido un error cargando el partido.</div>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <DateWrapper>
        <h2>FECHA</h2>
        <p>
          {match.matchDate
            ? new Date(match.matchDate).toLocaleString("es-ES", {
                timeZone: "Europe/Madrid",
              })
            : "Pendiente fecha"}
        </p>
      </DateWrapper>
      <Drafts>
        <h2>DRAFTS</h2>
        <p className="draft-link">
          <a
            href={match.mapDraft}
            target="_blank"
            rel="noopener noreferrer"
            className={!match.mapDraft ? "no-draft-link" : ""}
          >
            <img
              className="icon"
              src="https://www.aoe2cm.net/images/aoe2cm2.png"
              alt="Draft de mapas"
            />
            <span>
              {match.mapDraft ? (
                "Draft de mapas"
              ) : (
                <i>Aún no hay draft de mapas</i>
              )}
            </span>
          </a>
        </p>
        <p className="draft-link">
          <a
            href={match.civDraft}
            target="_blank"
            rel="noopener noreferrer"
            className={!match.civDraft ? "no-draft-link" : ""}
          >
            <img
              className="icon"
              src="https://www.aoe2cm.net/images/aoe2cm2.png"
              alt="Draft de civis"
            />
            <span>
              {match.civDraft ? (
                "Draft de civis"
              ) : (
                <i>Aún no hay draft de civis</i>
              )}
            </span>
          </a>
        </p>
      </Drafts>
      <Games>
        <h2>PARTIDAS</h2>
        <div className="games">
          {gameIds.length === 0 ? (
            <div>No hay info de los ids de partidas disponible</div>
          ) : (
            ""
          )}
          {gameIds.map((game) => {
            return (
              <div className="game" key={`gameId-${game.sequence}`}>
                <span className="game-no">{game.sequence}</span>
                <span>
                  <i>{game.gameAoe2Id ? game.gameAoe2Id : "Pendiente"}</i>
                </span>
              </div>
            );
          })}
        </div>
      </Games>
      <Results>
        <h2>RESULTADOS</h2>
        <div style={{ marginBottom: "2rem" }}>
          Sistema de competición: <b>{match.gamesFormat}</b> (
          {match.gamesFormat === "PA3" ? (
            <i>Se juegan los 3 mapas siempre</i>
          ) : (
            ""
          )}
          {match.gamesFormat === "BO5" ? (
            <i>
              Se juega al mejor de 5, es decir, el primero en ganar 3 mapas
              gana.
            </i>
          ) : (
            ""
          )}
          )
        </div>
        <div
          className="spoiler-options"
          onClick={() => switchSpoiler(showSpoiler)}
        >
          <TfiEye />{" "}
          {!showSpoiler ? "Mostrar resultados" : "Ocultar resultados"}
        </div>
        {showSpoiler ? (
          <div className="result">
            <span className="aw">{match.playerAaw}</span> {match.playerAresult}
            {" : "}
            {match.playerBresult} <span className="aw">{match.playerBaw}</span>
          </div>
        ) : (
          ""
        )}
        {showSpoiler ? (
          <div className="games">
            {match.games.map((game) => {
              return (
                <ResultsGame key={`game-result-${game.sequence}`}>
                  <div className="winner">
                    {game.gameWinner === match.playerAid ? <TfiCrown /> : ""}
                  </div>
                  <div className="player-name">{match.playerAusername}</div>
                  <div className="civ">
                    <img
                      src={`https://alexocampos.github.io/liga-espanhola-aoe2-static/civs/${
                        game.gameCivA ? game.gameCivA : "generic_civ"
                      }.png`}
                      alt={game.gameCivA}
                    />
                  </div>
                  <div className="map">
                    <img
                      src={`https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/${
                        game.map ? game.map : "cm_generic"
                      }.png`}
                      alt={game.map}
                    />
                  </div>
                  <div className="civ">
                    <img
                      src={`https://alexocampos.github.io/liga-espanhola-aoe2-static/civs/${
                        game.gameCivB ? game.gameCivB : "generic_civ"
                      }.png`}
                      alt={game.gameCivB}
                    />
                  </div>
                  <div className="player-name">{match.playerBusername}</div>
                  <div className="winner">
                    {game.gameWinner === match.playerBid ? <TfiCrown /> : ""}
                  </div>
                </ResultsGame>
              );
            })}
            {match.games.length < 1 ? (
              <ResultsGame>Not played yet</ResultsGame>
            ) : (
              ""
            )}
            {match.games.length < 2 ? (
              <ResultsGame>Not played yet</ResultsGame>
            ) : (
              ""
            )}
            {match.games.length < 3 ? (
              <ResultsGame>Not played yet</ResultsGame>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </Results>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  @media (max-width: 800px) {
  }
`;

const DateWrapper = styled.section`
  margin-top: 3rem;
`;

const Drafts = styled.section`
  margin-top: 3rem;
  .draft-link a {
    display: flex;
    align-items: center;

    img {
      width: 1.2rem;
    }

    span {
      margin-left: 0.8rem;
    }
  }

  .no-draft-link {
    cursor: default;
  }
  .no-draft-link:hover {
    color: var(--clr-grey-1);
  }
`;

const Games = styled.section`
  margin-top: 3rem;
  .games {
    display: flex;
    flex-wrap: wrap;
  }
  .game {
    display: flex;
    margin-right: 0.8rem;
    span {
      margin-left: 0.2rem;
    }
  }
  .game-no {
    width: 1.5rem;
    height: 1.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    text-align: center;
    display: flex;
    color: var(--clr-grey-1);
    background-color: var(--clr-violet);
  }
`;

const ResultsGame = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 2rem;

  .winner {
    width: 3%;
    display: flex;
    justify-content: center;
  }
  .player-name {
    width: 30%;
  }
  .civ {
    width: 8%;
    display: flex;
    justify-content: center;
  }
  .map {
    width: 18%;
    display: flex;
    justify-content: center;
  }

  .civ img {
    width: 4rem;
  }

  .map img {
    width: 8rem;
    z-index: -10;
  }

  @media (max-width: 800px) {
    .civ img {
      width: 2.8rem;
    }

    .map img {
      width: 5rem;
      z-index: -10;
    }
  }
`;

const Results = styled.section`
  margin-top: 3rem;
  width: 100%;

  .spoiler-options {
    cursor: pointer;
    :hover {
      color: var(--clr-primary-light-2);
    }
  }
  .result {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .aw {
      width: 4rem;
      min-width: 4rem;
      font-size: 1.5rem;
      margin-left: 2rem;
      margin-right: 2rem;
    }
  }

  .game {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  @media (max-width: 800px) {
    .result {
      width: auto !important;
      min-width: auto !important;
      font-size: 3.5rem !important;
    }
    .aw {
      width: auto !important;
      min-width: auto !important;
    }
  }
`;

export default MatchDetailSpectator;
